import { Loader } from '@googlemaps/js-api-loader'

const MAP_BACKGROUND_CLASS = 'listing-content__map--background'
const section = document.querySelector('.listing-content-section')
const container = section.querySelector('.listing-content__map')

function markerClickHandler(position) {
    const address = section.dataset.address
    window.open(
        `https://www.google.com/maps/dir/${section.dataset.title + ' ' + address},15z`,
        '_blank'
    )
}

function addMarker(map, position) {

    const infoWindow = new google.maps.InfoWindow({
        content: '',
    })

    const marker = new google.maps.Marker({
        position,
        map,
        icon: document.querySelector('#MAP_MARKER').value
    })

    const label = section.dataset.title

    /*marker.addListener('click', () => {
        markerClickHandler(position)
    })*/
}

function setup() {

    const center = {
        lat: parseFloat(section.dataset.lat),
        lng: parseFloat(section.dataset.lng)
    }

    const options = {
        center,
        zoom: 16,
        mapId: document.querySelector('#MAP_ID').value
    }

    const map = new google.maps.Map(container, options)

    addMarker(map, center)
    centerMap(map)
}

function centerMap(map) {

    const hasContent = document.querySelector('.listing-content__alignment') !== null

    if (!section.classList.contains(MAP_BACKGROUND_CLASS) || !hasContent) {
        return
    }

    const w = section.getBoundingClientRect().width / 12
    const offsetX = (w * 5 / 2) * -1

    map.panBy(offsetX, 0)
}

export function main() {

    if (!container || !section) {
        return
    }
    const API_KEY = section.dataset.key;

    if (!API_KEY) {
        throw 'Google maps will not work without an API_KEY'
    }

    const loader = new Loader({
        apiKey: API_KEY,
    })

    loader.load().then(setup)

}
